import { render, staticRenderFns } from "./ApplyBySystem.vue?vue&type=template&id=010b5c1f&scoped=true"
import script from "./ApplyBySystem.vue?vue&type=script&lang=js"
export * from "./ApplyBySystem.vue?vue&type=script&lang=js"
import style0 from "./ApplyBySystem.vue?vue&type=style&index=0&id=010b5c1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b5c1f",
  null
  
)

export default component.exports